import type { Level } from "./types";

/**
 * The five rooms. Each is a prize-collecting capacitated routing instance:
 * more loot than a player can ever haul, a small per-trip carrying capacity
 * (so loot must be banked at the cart in several round trips) and a step
 * budget that runs out when the monster arrives. The layouts come from the
 * seeded design search in `scripts/tune-levels.mjs`; every `opt` below is the
 * proven-best bankable prize, re-proven by a real HiGHS solve in levels.test.ts
 * (and again, live, in the reveal). Designed as traps: the obvious greedy haul
 * falls short of the optimum on every room (see levels.test.ts).
 */
export const LEVELS: Level[] = [
  { name: "Antechamber", cols: 7, rows: 7, capacity: 4, budget: 22, opt: 57,
    points: [[3, 3], [3, 0], [0, 6], [6, 2], [3, 5], [2, 1]],
    loot: [{ prize: 13, weight: 1 }, { prize: 16, weight: 1 }, { prize: 6, weight: 1 }, { prize: 12, weight: 2 }, { prize: 16, weight: 3 }] },
  { name: "Old Mineworks", cols: 9, rows: 7, capacity: 4, budget: 28, opt: 62,
    points: [[4, 3], [3, 3], [0, 0], [4, 5], [5, 5], [1, 1], [8, 0]],
    loot: [{ prize: 9, weight: 1 }, { prize: 8, weight: 1 }, { prize: 9, weight: 1 }, { prize: 14, weight: 3 }, { prize: 15, weight: 2 }, { prize: 15, weight: 2 }] },
  { name: "Flooded Gallery", cols: 9, rows: 9, capacity: 5, budget: 37, opt: 84,
    points: [[4, 4], [6, 5], [2, 0], [7, 6], [4, 6], [5, 2], [8, 0], [4, 1], [1, 0]],
    loot: [{ prize: 13, weight: 4 }, { prize: 20, weight: 2 }, { prize: 12, weight: 3 }, { prize: 10, weight: 1 }, { prize: 6, weight: 3 }, { prize: 17, weight: 4 }, { prize: 16, weight: 3 }, { prize: 13, weight: 1 }] },
  { name: "Collapsing Vault", cols: 11, rows: 9, capacity: 5, budget: 57, opt: 105,
    points: [[5, 4], [0, 1], [7, 3], [4, 7], [2, 7], [9, 7], [1, 1], [2, 1], [0, 4], [2, 8], [10, 8]],
    loot: [{ prize: 17, weight: 4 }, { prize: 7, weight: 2 }, { prize: 17, weight: 1 }, { prize: 20, weight: 4 }, { prize: 9, weight: 3 }, { prize: 13, weight: 3 }, { prize: 9, weight: 2 }, { prize: 20, weight: 1 }, { prize: 6, weight: 4 }, { prize: 6, weight: 4 }] },
  { name: "The Deep Hoard", cols: 11, rows: 11, capacity: 6, budget: 47, opt: 145,
    points: [[5, 5], [6, 8], [3, 3], [1, 10], [3, 6], [7, 7], [7, 10], [7, 2], [5, 0], [1, 8], [5, 4], [9, 2]],
    loot: [{ prize: 15, weight: 1 }, { prize: 20, weight: 2 }, { prize: 17, weight: 3 }, { prize: 21, weight: 5 }, { prize: 23, weight: 2 }, { prize: 11, weight: 4 }, { prize: 19, weight: 2 }, { prize: 8, weight: 5 }, { prize: 17, weight: 3 }, { prize: 24, weight: 2 }, { prize: 6, weight: 3 }] },
];

/** Total prize on a room's floor (the most that physically exists). */
export function totalPrize(level: Level): number {
  return level.loot.reduce((s, l) => s + l.prize, 0);
}
